export enum TipoContenedor{
        Indeterminado,
        Tanque,
        Poliducto,
        Cisterna,
        Abastecedora,
        Deposito,
}